import { type SavedConfigurationDTO } from "~/features/configurator/Linear/dtos";
import { type SavedConfiguration } from "~/features/configurator/Linear/models";
import { transformToExternalUrl } from "~/features/configurator/common/translationUtils";
import { UNIT_CONFIGURATOR_PRODUCT_CODE } from "~/domains/configurator/constants";

export function transformSavedConfig(dto: SavedConfigurationDTO[]): SavedConfiguration[] {
  return dto.map(transformSingle);
}

const transformSingle = (dto: SavedConfigurationDTO): SavedConfiguration => {
  const sapMaterialId = dto.schaefflerId ?? "";
  const isOldConfigurator = sapMaterialId === UNIT_CONFIGURATOR_PRODUCT_CODE;
  const shortDescription = dto.shortDescription ?? "";

  return {
    ...dto,
    name: dto.name || "",
    schaefflerId: sapMaterialId,
    manufacturerUrl: dto.manufacturerUrl || "",
    shortDescription: isOldConfigurator
      ? resolvePotentiallyExternalLabel(shortDescription, dto.baseExternalUrl)
      : shortDescription,
    useXmlTranslation: !isOldConfigurator,
    isSelected: false,
    showComment: dto.showComment ?? false,
    comment: dto.comment ?? "",
    importUrlPrefix: dto.importUrlPrefix ?? "",
  };
};

export function resolvePotentiallyExternalLabel(label: string, baseExternalUrl: string) {
  return label.toLowerCase().startsWith("http") ? label : transformToExternalUrl(label, baseExternalUrl);
}
